import comp from "./AssessmentToolAccordionTable";
export default comp;
